import classNames from 'classnames';
import { Fragment } from 'react';

import {
	Connection,
	ConnectionSlot,
	ConnectionStop,
	ConnectionTime,
	Time,
} from '@flixbus/honeycomb-react';

import { ACTIVITY_TYPE_LABELS } from 'utils/extraActivityLabels';

import { ASSIGNMENT_DETAILS_SIDEBAR_TEXT } from '../text';
import {
	buildRouteData,
	createExtraTimeProps,
	createTimeProps,
	getExtraActivityKey,
	getStationKey,
} from './utils';

import styles from './styles.module.css';

const renderTime = (timeProps) => (timeProps ? <Time {...timeProps} /> : undefined);

const RouteBlock = ({ selectedTimezone, stations, extraActivities, workAssignments }) => {
	const routeToRender = buildRouteData(stations, extraActivities, workAssignments);

	return (
		<Connection extraClasses={styles.fullwidth}>
			{routeToRender.map((routeItem, index) => {
				if (routeItem.type === 'extra') {
					const isFirst = index === 0;
					const isLast = index === routeToRender.length - 1;
					const extraActivityKey = getExtraActivityKey(routeItem.data, index);
					const label = ACTIVITY_TYPE_LABELS[routeItem.data.activityType];

					return (
						<Fragment key={extraActivityKey}>
							{!isFirst && (
								<ConnectionSlot key={`${extraActivityKey}-before`}>
									<div className={styles.blank} />
								</ConnectionSlot>
							)}

							<ConnectionSlot key={`${extraActivityKey}-content`}>
								<div className={styles.extraActivities}>
									{isFirst && (
										<div className={styles.marker}>
											<div className={styles.circle} />
											<div className={styles.stem} />
										</div>
									)}
									{isLast && (
										<div className={classNames(styles.marker, styles.flipped)}>
											<div className={styles.circle} />
											<div className={styles.stem} />
										</div>
									)}
									{!isFirst && (
										<div className={classNames(styles.stemMask, styles.top)}>
											<div className={classNames(styles.stem, styles.large)} />
										</div>
									)}
									{!isLast && (
										<div className={classNames(styles.stemMask, styles.bot)}>
											<div className={classNames(styles.stem, styles.large)} />
										</div>
									)}
									<span
										className={classNames(styles.span, {
											[styles.translatedLeft]: !isFirst && !isLast,
										})}
									>
										{label}
									</span>
									<div className={styles.extraTime}>
										<div>
											{renderTime(
												createExtraTimeProps(routeItem.data.fromTimestamp, selectedTimezone)
											)}
										</div>
										<div>
											{renderTime(
												createExtraTimeProps(routeItem.data.toTimestamp, selectedTimezone)
											)}
										</div>
									</div>
								</div>
							</ConnectionSlot>
							{!isLast && (
								<ConnectionSlot key={`${extraActivityKey}-after`}>
									<div className={styles.blank} />
								</ConnectionSlot>
							)}
						</Fragment>
					);
				}

				const timeProps = createTimeProps(routeItem.data, selectedTimezone);

				return (
					<ConnectionStop
						key={getStationKey(routeItem.data, index)}
						station={
							<div className={styles.station}>
								{routeItem.data.code}(
								{routeItem.data.isOperational
									? ASSIGNMENT_DETAILS_SIDEBAR_TEXT.operationalStop
									: routeItem.data.name}
								)
							</div>
						}
						time={
							<ConnectionTime
								time={renderTime(timeProps.time)}
								secondTime={renderTime(timeProps.secondTime)}
							/>
						}
					/>
				);
			})}
		</Connection>
	);
};

export default RouteBlock;
